(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["domain.result.htm"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"content result\">\r\n\t<div class=\"container\">\r\n\t\t<div class=\"row\">\r\n\t\t\t<div class=\"col-md-12 nopadding\">\r\n\t\t\t\t<h2 data-load-title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"loading")),"text"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"family")),"results_by_family"), env.opts.autoescape);
output += "</h2>\r\n\t\t\t\t<div class=\"col-md-3 domain-list\">\r\n\t\t\t\t\t<div class=\"domain_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"id"), env.opts.autoescape);
output += " domain-container\">\r\n\t\t\t\t\t\t<div class=\"cat-domain\">\r\n\t\t\t\t\t\t\t<div class=\"icn-domaine-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"slug"), env.opts.autoescape);
output += " domain-icon\"></div>\r\n\t\t\t\t\t\t\t<span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"nom"), env.opts.autoescape);
output += "</span>\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "families");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("family", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\r\n\t\t\t\t\t\t\t<div class=\"family-name\" data-family-cta=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\" data-family-prc=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"prc"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t<div class=\"progress\" data-width=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"prc"), env.opts.autoescape);
output += "%\"></div>\r\n\t\t\t\t\t\t\t\t<div class=\"text\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"name\">\r\n\t\t\t\t\t\t\t\t\t\t<h6>";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"prc"), env.opts.autoescape);
output += "%</h6>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t<div class=\"loading\">\r\n\t\t\t\t\t\t<span class=\"loading-dot\"></span>\r\n\t\t\t\t\t\t<span class=\"loading-dot\"></span>\r\n\t\t\t\t\t\t<span class=\"loading-dot\"></span>\r\n\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t<div class=\"notefamily\">\r\n\t\t\t\t\t\t";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"family")),"footnote")), env.opts.autoescape);
output += "\r\n\t\t\t\t\t</div>\r\n\r\n\t\t\t\t</div> <!--fin de la colonne des familles -->\r\n\r\n\t\t\t\t<div class=\"col-md-offset-1 col-md-8 nopadding\">\r\n\t\t\t\t\t<div class=\"light-box family-container\" data-family-desc>\r\n\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div> <!--fin de la light-box -->\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
